// extracted by mini-css-extract-plugin
export default {"TooltipOnro":"style_TooltipOnro__yxqdX"};